import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as Endpoints from "../../entities/Endpoints";
import {
  fetchClientInformation,
  updatetClientInformation,
} from "../../api/clientInfoApi";
import { fetchMembershipOverview } from "./membershipOverviewSlice";

// **Async thunk to fetch client information (GET)**
export const getClientInformation = createAsyncThunk(
  Endpoints.GET_CLIENT_INFORMATION,
  async ({ clientId, coachId }, { rejectWithValue }) => {
    try {
      const response = await fetchClientInformation({ clientId, coachId });
      return response.clientInformation;
    } catch (error) {
      return rejectWithValue(error || "An unexpected error occurred.");
    }
  }
);

export const postClientInformation = createAsyncThunk(
  Endpoints.POST_CLIENT_INFORMATION,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await updatetClientInformation(payload);
      dispatch(
        getClientInformation({
          clientId: payload.clientId,
          coachId: payload.coachId,
        })
      );

      // Call fetchMembershipOverview from another slice
      dispatch(fetchMembershipOverview(payload.clientId));

      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          "An error occurred while saving client information."
      );
    }
  }
);

const clientSlice = createSlice({
  name: "clientInformation",
  initialState: {
    clientData: null,
    loading: false,
    error: null,
    postError: null,
    postSuccess: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClientInformation.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.postError = null;
        state.postSuccess = null;
      })
      .addCase(getClientInformation.fulfilled, (state, action) => {
        state.clientData = action.payload;
        state.loading = false;
        state.postError = null;
        state.postSuccess = null;
      })
      .addCase(getClientInformation.rejected, (state, action) => {
        state.loading = false;
        state.clientData = null;
        state.error = action.payload || "An unexpected error occurred.";
        state.postError = null;
        state.postSuccess = null;
      });

    // **POST Client Information**
    builder
      .addCase(postClientInformation.pending, (state) => {
        state.loading = true;
        state.postError = null;
        state.postSuccess = null;
      })
      .addCase(postClientInformation.fulfilled, (state, action) => {
        state.loading = false;
        state.postSuccess = action.payload?.message;
        state.postError = null;
        state.error = null;
      })
      .addCase(postClientInformation.rejected, (state, action) => {
        state.loading = false;
        state.postSuccess = false;
        state.postError =
          action.payload || "Failed to save client information.";
        state.error = null;
      });
  },
});

export default clientSlice.reducer;
